import { Box, chakra, useColorModeValue, Flex, GridItem, Text } from '@chakra-ui/react';
import React from 'react';

import Skeleton from 'ui/shared/chakra/Skeleton';
import Hint from 'ui/shared/Hint';

interface Props {
  label: string;
  content: string | React.ReactNode;
  className?: string;
  isLoading: boolean;
  hint?: string;
}

const ContractDetailsInfoItem = ({ label, content, className, isLoading, hint }: Props) => {
  const hintIconColor = useColorModeValue('gray.600', 'gray.400');
  const labelColor = useColorModeValue('#616161', '#999999');
  const valueColor = useColorModeValue('#000000', '#FFFFFF');

  return (
    <GridItem
      display="flex"
      flexDir={{ base: 'column', md: 'row' }}
      rowGap={{ base: 1, md: 0 }}
      columnGap={ 6 }
      wordBreak="break-all"
      className={ className }
      alignItems={{ base: 'flex-start', md: 'baseline' }}
    >
      <Skeleton isLoaded={ !isLoading } w={{ base: '100%', md: '190px' }} flexShrink={ 0 }>
        <Flex alignItems="center" color={ labelColor } fontSize="14px" lineHeight="20px" fontWeight={ 500 }>
          <Text as="span">{ label }</Text>
          { hint && (
            <Hint
              label={ hint }
              ml={ 2 }
              color={ hintIconColor }
              tooltipProps={{ placement: 'bottom' }}
            />
          ) }
        </Flex>
      </Skeleton>
      <Skeleton isLoaded={ !isLoading } minH="20px">
        <Box color={ valueColor } fontSize="16px" lineHeight="24px" fontWeight={ 500 }>
          { content }
        </Box>
      </Skeleton>
    </GridItem>
  );
};

export default React.memo(chakra(ContractDetailsInfoItem));
